import { CvDataInterface, CvInterface } from "../types";
import {
  apiGetCharacteristics,
  apiGetCourses,
  apiGetKnowledgeDomains,
} from "@/modules/consultant_profiles/_utils/api";
import { apiGetSkillCategories, apiGetSkills } from "@/modules/skills/_utils/api";
import { apiGetUser } from "@/modules/users/_utils/api";
import axios from "@/network";

export function apiGetCvs(params: any) {
  const url = `/cvs`;
  return axios.get(url, { params });
}

export function apiUpdateCv(updatedCv: CvInterface) {
  const url = `/cvs/${updatedCv.id}`;
  const payload = { cv: updatedCv };
  return axios.patch(url, payload);
}

export function apiCreateCv(cv: Partial<CvInterface>) {
  const url = "/cvs";
  const payload = { cv };
  return axios.post(url, payload);
}

export function apiDeleteCv(cvId: number) {
  const url = `/cvs/${cvId}`;
  return axios.delete(url);
}

export function apiGetCv(cvId: number, languageCode: string) {
  const url = `/cvs/${cvId}`;
  return axios.get(url, {
    headers: {
      "Accept-Language": languageCode,
    },
  });
}

export function apiGetSharedCv(shareToken: string, languageCode: string) {
  const url = `/cvs/interactive/${shareToken}`;
  return axios.get(url, {
    headers: {
      "Accept-Language": languageCode,
    },
  });
}

export function apiGetPreviewCv(previewCv: CvInterface, languageCode: string) {
  const url = `/cvs/${previewCv.id}/preview`;
  const headers = { "Accept-Language": languageCode };
  return axios.post(url, { cv: previewCv }, { headers });
}

export function apiGetCvData(cvId: number) {
  const url = `/cvs/${cvId}/data`;
  return axios.get(url);
}

export async function apiGetCvDataForUser(userId: number): Promise<CvDataInterface> {
  const [user, characteristics, courses, knowledgeDomains, skillCategories, skills] =
    await Promise.all([
      apiGetUser(userId),
      apiGetCharacteristics(),
      apiGetCourses(),
      apiGetKnowledgeDomains(),
      apiGetSkillCategories(),
      apiGetSkills(),
    ]);

  return {
    user: user.data.data,
    characteristics: characteristics.data.data,
    courses: courses.data.data,
    knowledge_domains: knowledgeDomains.data.data,
    skill_categories: skillCategories.data.data,
    skills: skills.data.data,
  };
}
